import "@/global.less";
import { queryCurrentUser } from "@/services/userApi";
import { getAuth } from "@/utils/db";
import { requestConfig } from "@/utils/request";
import { history, useLocation } from "@umijs/max";
import { Image as MobileImage, Toast } from "antd-mobile";
import "antd-mobile/es/global";
import { stringify } from "querystring";
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import defaultSettings from '../config/defaultSettings';
import logo from "@/assets/icon/logo.svg";

// 开发环境调试工具
const isDev = process.env.NODE_ENV === "development";
if (isDev) {
  import("vconsole").then(({ default: VConsole }) => new VConsole());
}
const loginPath = "/user/login";

// 统一登录跳转（单页应用方式）
const gotoLogin = (logout?, arg = {}) => {
  const { pathname, query } = history.location;
  if (pathname?.startsWith("/user") && pathname !== loginPath) return;
  if (pathname !== loginPath) {
    const queryStr = Object.keys(query).length > 0 ? `?${stringify(query)}` : "";
    const redirect = encodeURIComponent(`${pathname}${queryStr}`);
    history.push({
      pathname: loginPath,
      query: { redirect, ...arg?.query },
    });
  }
};

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await queryCurrentUser();
    return response.data;
  } catch (error) {
    gotoLogin();
    return undefined;
  }
};
export async function getInitialState(): Promise<{
    settings?: Partial<LayoutSettings>;
    currentUser?: API.CurrentUser;
    loading?: boolean;
    fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
    const fetchUserInfo = async () => {
        try {
            const res = await queryCurrentUser();
            return res.data;
        } catch (error) {
            //history.push(loginPath);
        }
        return undefined;
    };
    // 如果不是登录页面，执行
    const { location } = history;
    const token= getAuth()
    if(token){
        const currentUser = await fetchUserInfo();
        return {
            fetchUserInfo,
            currentUser:{...currentUser,name:currentUser.user_name},
            settings: defaultSettings as Partial<LayoutSettings>,
        };
    }
    return {
        fetchUserInfo,
        currentUser:{},
        settings: defaultSettings as Partial<LayoutSettings>,
    };

}
// 初始化状态
async function initState() {
  const { location } = history;
  const token = getAuth();

  // 登录页面不执行用户信息获取
  if ([loginPath].includes(location.pathname)) {
    return { fetchUserInfo, settings: {} };
  }

  // 有 token 时尝试获取用户信息
  if (token) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser: currentUser ? { ...currentUser, name: currentUser.user_name } : undefined,
      settings: {},
    };
  }

  // 无 token 且非登录页，跳转登录
  gotoLogin();
  return { fetchUserInfo, currentUser: undefined, settings: {} };
}

// 布局配置
export const layout = ({ initialState, setInitialState }) => {
  const location = useLocation();
  return {
    ...initialState?.settings,
    title: false, // 标题由 MobileHeader 控制
    logo: <MobileImage src={logo} className="header-title" height={24} />,
    breadcrumbRender: false,
    // 页面内容
    childrenRender: (children) => {
      if (initialState?.loading) return null;
      const isAccountPage = location.pathname.includes('/account/');
      return (
        <div className={`page-container ${isAccountPage ? 'hide-menu' : ''}`}>
          {children}
        </div>
      );
    },
    // 路由切换处理
    onPageChange: () => {
      const { location } = history;
      if (location.pathname.includes('/mine/') && !initialState?.currentUser?.name) {
        history.push(loginPath);
      }
    },
      footerStyle: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#fff',
      height: 50,
      borderTop: '1px solid #e8e8e8',
    },
  };
};

// 请求配置
export const request = {
  ...requestConfig,
  timeout: 10000,
  errorConfig: {
    errorHandler: (error) => {
      if (error.response) {
        Toast.show(`错误: ${error.response.data?.message || "服务器异常"}`);
      } else if (error.request) {
        Toast.show("网络连接失败，请检查网络");
      }
    },
  },
};